<div class="container-lg">
  <div class="row">
    <div class="col-12">
      <section class="home-page"></section>
    </div>
  </div>
</div>
